import { types as sessionTypes } from '@clearscore/redux.session';
import { resetUser } from '@clearscore/helpers.segment';
import { removeSessionCookie } from '@clearscore/helpers.cookies';

/**
 * Check if action is a logout error or success or a timeout
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function _isLogoutAction(action) {
    return (
        action.type === sessionTypes.LOGOUT_SUBMIT_SUCCESS ||
        action.type === sessionTypes.LOGOUT_SUBMIT ||
        action.type === sessionTypes.LOGOUT_SUBMIT_ERROR
    );
}

/**
 * Handle the removing of the session cookie
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @param {function} coreDispatch method to dispatch across core store
 * @returns {void}
 */
function _handleRemovingSession(next, action, coreDispatch) {
    removeSessionCookie();
    resetUser();
    if (coreDispatch) {
        coreDispatch(action);
    }
    next(action);
}

/**
 * If action has correct signature, perform cookie storage
 * @returns {Function} middleware
 */
const logoutMiddleware = (coreDispatch) => () => (next) => (action) =>
    _isLogoutAction(action) ? _handleRemovingSession(next, action, coreDispatch) : next(action);

export default logoutMiddleware;
